/**
 * Redirect expieriment constants
 */
export const redirectExperiment = {
  DATE_THRESHOLD: '2023-07-17'
}
